// /* eslint-disable */
import React from 'react';
import
{
    Box,
    TextField,
    MenuItem,

} from '@mui/material';
import Game_jersey from '../../assets/images/Game_jersey.svg';
import Game_short from '../../assets/images/Game_short.svg';
import Warm_up_shirt from '../../assets/images/warm_up_tshirt.svg';
import Compression_tank from '../../assets/images/compression_tank.svg';
import Compression_short from '../../assets/images/compression_short.svg';
import Compression_full_tight from '../../assets/images/compression_full_tight.svg';
import Short_sleeve_polo from '../../assets/images/short_sleeve_polo.svg';
import Mens_zip from '../../assets/images/mens_1fourth_zip.svg';
import Short_sleeve_tshirt from '../../assets/images/short_sleeve_tshirt.svg';
import Long_sleeve_tshirt from '../../assets/images/long_sleeve_tshirt.svg';
import SweatShirt from '../../assets/images/fleece_sweatshirt.svg';
import SweatPant from '../../assets/images/fleece_sweatpant.svg';
import Training_short from '../../assets/images/training_short.svg';
import FleeceTop from '../../assets/images/fleece_sweatshirt.svg';
import FleecePant from '../../assets/images/fleece_sweatpant.svg';
import Socks from '../../assets/images/sock.svg';


const icons = {
    gameJersey: Game_jersey,
    gameShort: Game_short,
    warmupShirt: Warm_up_shirt,
    compressionTank: Compression_tank,
    compressionShort: Compression_short,
    gameJerseyGLeague: Game_jersey,
    gameShortGLeague: Game_short,
    warmupShirtGLeague: Warm_up_shirt,
    compressionTankGLeague: Compression_tank,
    compressionShortGLeague: Compression_short,
    compressionFullTight: Compression_full_tight,
    shortSleevePolo: Short_sleeve_polo,
    mensZip: Mens_zip,
    shortSleevePoloGLeague: Short_sleeve_polo,
    mensZipGLeague: Mens_zip,
    shortSleeveTShirt: Short_sleeve_tshirt,
    longSleeveTShirt: Long_sleeve_tshirt,
    longSleeveTShirtOff: Long_sleeve_tshirt,
    fleeceSweatShirt: SweatShirt,
    fleeceSweatPants: SweatPant,
    trainingShort: Training_short,
    fleeceTop: FleeceTop,
    fleecePant: FleecePant,
    fleeceTopGLeague: FleeceTop,
    fleecePantGLeague: FleecePant,
    polo: Short_sleeve_polo,
    womensZip: Mens_zip,
    sock: Socks,
}
const OutfitOptionType = (props) =>
{
    // const classes = useStyles();
    const { data, editPermission, value, classes } = props;
    // console.log("data.OutfitName",data.OutfitName);
    const icon = icons[data.OutfitName.toString()];
    //const TagName = components[props.button.icon.toString()];
    return (
        <Box className={classes.inputBox}>
            <Box
                component="img"
                alt={data.OutfitType}
                src={icon}
                className={classes.inputIcon}
            />
            <TextField
                required
                disabled={!editPermission}
                size="small"
                fullWidth
                label={data.OutfitType}
                select
                value={value}
                onChange={(e) => props.setOutfitValue(e.target.value, data.OutfitName)}>
                {data.Values && data.Values.length > 0 &&
                    data.Values.map((option, index) => (
                        <MenuItem
                            key={`${data.OutfitName}_${index}`}
                            value={option.value}>
                            {option.value}
                        </MenuItem>
                    ))}
            </TextField>
        </Box>
    );
};

export default OutfitOptionType;